import { createAction } from 'redux-actions';

import { keyTransform } from 'util/helper';

import { wrapFetch } from './endpoint';

export const getFacilities = createAction('FETCH_FACILITIES', async (lan, hotel) => {
	const { status, message, data } = await wrapFetch(`api/v1/web/${lan}/${hotel}/facility`, {
		method: 'GET',
	});

	if (status !== 200) {
		throw new Error(message);
	}

	const facilityList = [];
	const facilityData = {};

	data.forEach(d => {
		facilityList.push(d.id);
		facilityData[d.id] = {
			...keyTransform(d),
			time: d.time.split('、'),
			photos: d.photos.map(photo => photo.url),
			thumbnail: d.photos.map(photo => photo.thumb_url),
		};
	});

	return {
		facilityList,
		facilityData,
	};
});



// WEBPACK FOOTER //
// ./src/actions/facility.js